import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import 'materialize-css/dist/css/materialize.min.css'
import 'materialize-css/dist/js/materialize.min.js'
import './index.css'
import './client/DarkMode.css'

ReactDOM.render(
    <App />,
    document.getElementById('root')
)
